const initialState = {
  data: {},
  apiStatus: '',
  apiStatusMessage: ''
};

export function myRewardsReducer(state = initialState, action) {
  const { type = '', data = {}, apiStatus = '', apiStatusMessage = '' } = action || {};
  switch (type) {
    case 'GET_MY_REWARDS_API_SUCCESS':
      return { ...state, data: { ...data }, apiStatus, apiStatusMessage };
    case 'GET_MY_REWARDS_API_ERROR':
      return { ...state, data, apiStatus, apiStatusMessage };
    default:
      return state;
  }
}
